//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class InvoiceStatusService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[InvoiceStatus.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/invoice-status/detail', {'params':params});
	};

	//GeneratorFlag:[InvoiceStatus.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/invoice-status/list', {'params':params});
	};

//GeneratorFlag:[NewAction]
}